import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { ArrowRight, Calendar, Tag } from 'lucide-react';

export const NewsPage: React.FC = () => {
  const { data: newsRes, isLoading } = useQuery({
    queryKey: ['public-news'],
    queryFn: () => api.get('/public/news').then((res) => res.data.data),
  });

  const news = newsRes || [];

  return (
    <div className="space-y-16 py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      {/* Header */}
      <section className="text-center space-y-4 max-w-3xl mx-auto">
        <span className="text-xs font-mono uppercase tracking-widest text-brand-600 font-bold">
          Publishing Press &amp; Insights
        </span>
        <h1 className="text-4xl sm:text-5xl font-serif font-bold text-editorial-dark">
          News &amp; Editorial Announcements
        </h1>
        <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
          Stay updated with official imprints, author releases, publishing announcements, and editorial reflections from For The Truth Publishing.
        </p>
      </section>

      {/* News Grid */}
      <section>
        {isLoading ? (
          <div className="text-center py-16 text-xs font-mono text-slate-500">Loading articles...</div>
        ) : news.length === 0 ? (
          <div className="text-center py-16 text-slate-500 text-sm">No articles available.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {news.map((item: any) => (
              <div
                key={item.id}
                className="group flex flex-col justify-between p-8 rounded-2xl bg-white border border-editorial-border hover:border-brand-300 hover:shadow-editorial-lg transition-all space-y-6"
              >
                <div className="space-y-4">
                  <div className="flex items-center justify-between text-xs text-slate-400 font-mono">
                    <span className="px-2.5 py-1 rounded bg-brand-50 text-brand-800 font-bold uppercase text-[10px]">
                      {item.category}
                    </span>
                    <span>
                      {new Date(item.publishedAt || item.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                    </span>
                  </div>

                  <h2 className="font-serif text-2xl font-bold text-slate-900 group-hover:text-brand-800 transition-colors">
                    {item.title}
                  </h2>

                  <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">
                    {item.excerpt}
                  </p>
                </div>

                <div className="pt-4 border-t border-slate-100 flex items-center justify-between">
                  <span className="text-xs text-slate-400 font-medium">By {item.author}</span>
                  <Link
                    to={`/news/${item.slug}`}
                    className="text-xs font-bold text-brand-700 hover:text-brand-800 inline-flex items-center gap-1"
                  >
                    <span>Read Announcement</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

    </div>
  );
};
